// src/config/wsServerDataExtractionConfig.js (NEW FILE)

/**
 * Defines the message types and STOMP topics for the Server Data Extraction module.
 */

export const WS_SERVER_DATA_TYPES = {
  // Client -> Server
  CONNECT_SERVER: 'EXTRACT_CONNECT_SERVER',
  DISCONNECT_SERVER: 'EXTRACT_DISCONNECT_SERVER',
  EXTRACT_DATA_REQUEST: 'EXTRACT_DATA_REQUEST',
  GET_STATE: 'EXTRACT_GET_STATE',
  GET_HISTORY: 'EXTRACT_GET_HISTORY', // New

  // Server -> Client
  CONNECTION_STATUS: 'EXTRACT_CONNECTION_STATUS',
  EXTRACTION_STARTED: 'EXTRACT_STARTED',
  EXTRACTION_COMPLETED: 'EXTRACT_COMPLETED',
  EXTRACTION_FAILED: 'EXTRACT_FAILED',
  CURRENT_STATE: 'EXTRACT_CURRENT_STATE',
  EXTRACTION_PROGRESS: 'EXTRACT_PROGRESS',
  ERROR: 'EXTRACT_ERROR',
  HISTORY_LIST: 'EXTRACT_HISTORY_LIST', // New
  HISTORY_ERROR: 'EXTRACT_HISTORY_ERROR', // New
};

export const WS_SERVER_DATA_TOPICS = {
  APP_ENDPOINT_BASE: '/server-data',
  CONNECT: '/connect',
  DISCONNECT: '/disconnect',
  EXTRACT: '/extract',
  GET_STATE: '/get-state',
  APP_GET_HISTORY: '/get-history', // New app endpoint path

  USER_QUEUE_BASE: '/user/queue/server-data',
  STATUS: '/status',
  PROGRESS: '/progress',
  ERROR: '/error',
  USER_HISTORY: '/history', // New user queue topic
};
  
  // Helper to build full app destination path
  export const getDataAppEndpoint = (action) => `${WS_SERVER_DATA_TOPICS.APP_ENDPOINT_BASE}${action}`;
  // Helper to build full user subscription topic path
  export const getDataUserQueueTopic = (subTopic) => `${WS_SERVER_DATA_TOPICS.USER_QUEUE_BASE}${subTopic}`;